import { render, staticRenderFns } from "./EndOrder.vue?vue&type=template&id=c37449f0&scoped=true&"
import script from "./EndOrder.vue?vue&type=script&lang=js&"
export * from "./EndOrder.vue?vue&type=script&lang=js&"
import style0 from "./EndOrder.vue?vue&type=style&index=0&id=c37449f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37449f0",
  null
  
)

export default component.exports